class Index {
    rc;
    _parent;
    constructor(_parent) {
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/bulk-add`;
    }
    /**
     * Adds multiple BYOD (customer provided) devices to an account.
     * HTTP Method: post
     * Endpoint: /restapi/v2/accounts/{accountId}/devices/bulk-add
     * Rate Limit Group: Heavy
     * App Permission: EditAccounts
     * User Permission: AddRemoveDevices
     */
    async post(bulkAddDevicesRequest, restRequestConfig) {
        const r = await this.rc.post(this.path(), bulkAddDevicesRequest, undefined, restRequestConfig);
        return r.data;
    }
}
export default Index;
